<template>
  <div class="form-group row">
    <div class="col-11 row">
      <div class="col-sm-2 text-sm-right">
        <label>Número Protocolo:</label>
      </div>
      <div class="col-md-4 col-sm-10 mb-3">
        <the-mask :mask="['##/######/####']" type="text" class="form-control" v-model="filtroTramitados.numeroProcesso"/>
      </div>

      <div class="col-sm-2 text-sm-right">
        <label>Número Guia:</label>
      </div>
      <div class="col-md-4 col-sm-10 mb-3">
        <input type="text" class="form-control" v-model="filtroTramitados.numeroGuia">
      </div>
    </div>

    <div class="col-11 row">
      <div class="col-sm-2 text-sm-right">
        <label>Assunto:</label>
      </div>
      <div class="col-sm-10 mb-3">
        <input type="text" class="form-control" v-model="filtroTramitados.assunto">
      </div>
    </div>

    <div class="col-11 row">
      <div class="col-sm-2 text-sm-right">
        <label>Período</label>
      </div>
      <div class="col-md-4 col-sm-10 mb-3">
        <input type="date" class="form-control" v-model="filtroTramitados.periodoInicio">
      </div>
      <div class="col-md-2 text-center">
        <label class="mt-2">a</label>
      </div>
      <div class="col-md-4 col-sm-10 mb-3">
        <input type="date" class="form-control" v-model="filtroTramitados.periodoFim">
      </div>
      <div class="erroData mb-2 col-5 text-center" v-if="validaPeriodo.exibeErro">** Data Inicial deve ser menor ou igual a data final</div>
    </div>

    <div class="col-12 row btnAcoes">
      <div class="col-1"></div>
      <button class="btn btn-outline-success" @click.prevent="pesquisar"> Pesquisar </button>
      <button class="btn btn-outline-danger" @click.prevent="limpar"> Limpar </button>
    </div>
  </div>
</template>

<script>
import eventBus from '@/uteis/eventBus'
import VirtusService from '@/services/VirtusService'

export default {
  name: 'filtroPesquisaTramitados',

  props: {
    rowsNumber: { required: true, type: Number },
    eventBusDataName: { required: true, type: String },
    eventBusPaginationName: { required: true, type: String }
  },

  data () {
    return {
      filtroTramitados: {
        numeroProcesso: '',
        numeroGuia: '',
        assunto: '',
        interessado: '',
        periodoInicio: '',
        periodoFim: '',
        offset: 1,
        range: this.rowsNumber
      },
      validaPeriodo: {
        inicio: 0,
        fim: 0,
        exibeErro: false
      }
    }
  },

  created () {
    eventBus.$on(this.eventBusPaginationName, (numeroPagina) => {
      this.trocaDePagina(numeroPagina)
    })

    this.service = new VirtusService()
    this.pesquisar()
  },

  validations: {
    filtroTramitados: {
      periodoInicio: {
        validarDataInicial: () => this.validarPeriodos()
      },
      periodoFim: {
        validarDataFinal: () => this.validarPeriodos()
      }
    }
  },

  methods: {
    pesquisar () {
      if (this.validarPeriodos()) {
        const dadosSessao = this.$store.getters.getDadosSessao
        this.filtroTramitados.tipoIdentificador = 'ID'
        this.filtroTramitados.identificador = dadosSessao.sessao.idDepartamento

        this.service.consultarProcessosTramitados(this.filtroTramitados).then(res => {
          eventBus.$emit(this.eventBusDataName, res)
        }).catch(err => {
          console.log(err)
        })
      }
    },

    limpar () {
      this.filtroTramitados.numeroProcesso = ''
      this.filtroTramitados.numeroGuia = ''
      this.filtroTramitados.assunto = ''
      this.filtroTramitados.interessado = ''
      this.filtroTramitados.periodoInicio = ''
      this.filtroTramitados.periodoFim = ''
      this.pesquisar()
    },

    trocaDePagina (numeroPagina) {
      this.filtroTramitados.offset = numeroPagina
      this.pesquisar()
    },

    validarPeriodos () {
      if (this.filtroTramitados.periodoInicio.length > 0 && this.filtroTramitados.periodoFim.length > 0) {
        // Covertendo data para Inteiro
        this.validaPeriodo.inicio = parseInt(this.filtroTramitados.periodoInicio.replace(/-/g, ''))
        this.validaPeriodo.fim = parseInt(this.filtroTramitados.periodoFim.replace(/-/g, ''))
        // Verificando Datas
        if (this.validaPeriodo.inicio > this.validaPeriodo.fim) {
          // "Zerando" variaveis de verificação
          this.validaPeriodo.inicio = 0
          this.validaPeriodo.fim = 0
          this.validaPeriodo.exibeErro = true
          return false
        }
      }
      this.validaPeriodo.exibeErro = false
      return true
    }
  },

  destroyed () {
    eventBus.$off(this.eventBusPaginationName)
  }
}
</script>

<style scoped lang="scss">

.row {
  margin-top: 2px;
}

.erroData{
  color: red;
  background-color: white;
}
</style>
